var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DialogArchives',{attrs:{"sn":_vm.id,"show":_vm.visible},on:{"update:show":function($event){_vm.visible=$event}}},[_c('ArchivesCard',{ref:"ArchivesCardRef",attrs:{"detail":_vm.archivesDetail,"sn":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }